export const formatMoney = (
  amount,
  symbol = '$',
  decimalCount = 2,
  decimal = '.',
  thousands = ','
) => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return [
      `${symbol} ${negativeSign}${j ? i.substr(0, j) + thousands : ''}${i
        .substr(j)
        .replace(/(\d{3})(?=\d)/g, '$1' + thousands)}`,
      // `${
      //   decimalCount
      //     ? decimal +
      //       Math.abs(amount - i)
      //         .toFixed(decimalCount)
      //         .slice(2)
      //     : ''
      // }`,
    ];
  } catch (e) {
    console.log(e);
  }
};

export const formatDate = (date) => {
  const dateArr = date.split('-');
  let month;

  switch (dateArr[1]) {
    case '01':
      month = 'January';
      break;
    case '02':
      month = 'February';
      break;
    case '03':
      month = 'March';
      break;
    case '04':
      month = 'April';
      break;
    case '05':
      month = 'May';
      break;
    case '06':
      month = 'June';
      break;
    case '07':
      month = 'July';
      break;
    case '08':
      month = 'August';
      break;
    case '09':
      month = 'September';
      break;
    case '10':
      month = 'October';
      break;
    case '11':
      month = 'November';
      break;
    case '12':
      month = 'December';
      break;

    default:
      break;
  }

  return `${month}-${dateArr[2]}-${dateArr[0]}`;
};
